<template>
  <div class="relative overflow-x-hidden flex-1 px-6 py-6 flex">
    <div class="flex-1">
      <!-- Title Bar -->
      <div
        class="flex items-center justify-between pb-4 border-b border-gray-300"
      >
        <div class="flex items-center space-x-6">
          <h1 class="text-2xl font-semibold text-gray-800">ส่งประกาศ</h1>
          <button
            :disabled="formAction === 'edit'"
            :class="{ 'cursor-not-allowed': formAction === 'edit' }"
            @click="addAnnouncement"
            type="button"
            class="
              inline-flex
              items-center
              px-4
              py-2
              border border-transparent
              rounded-md
              shadow-sm
              text-base
              font-semibold
              tracking-wider
              text-white
              bg-cyan-600
              hover:bg-cyan-700
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-cyan-500
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="-ml-1 mr-2 h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clip-rule="evenodd"
              />
            </svg>
            เพิ่มประกาศ
          </button>
        </div>

        <div class="flex items-center">
          <SearchWidgetResultsList v-model="search" />
        </div>
      </div>
      <!-- end title bar -->

      <!-- table -->
      <div class="mt-4">
        <AppDataTable
          :isCheckbox="false"
          :options="options"
          :headers="[
            {
              text: 'หัวข้อ',
              class: 'text-left',
              value: 'title',
            },
            {
              text: 'สร้างเมื่อ',
              class: 'text-left w-44',
              value: 'created_at',
            },
            {
              text: 'ส่งเมื่อ',
              class: 'text-left w-44',
              value: 'sent_datetime',
            },
            {
              text: 'ส่งถึง (บริษัท)',
              class: 'text-left w-44',
              value: 'stat.send',
            },
            {
              text: 'ประกาศหมดอายุ',
              class: 'text-left w-44',
              value: 'expired_datetime',
            },
          ]"
          :items="filterAnnouncements.items"
          :loading="loading"
          @sort="sort"
          :isNext="true"
          :rowClassFunction="rowClassFunction"
          @rowClick="onRowClick"
        >
          <template v-slot:created_at="{ item }">
            {{ item.created_at | formatDate }}
          </template>
          <template v-slot:sent_datetime="{ item }">
            {{ item.sent_datetime | formatDate }}
          </template>
          <template v-slot:expired_datetime="{ item }">
            {{ item.expired_datetime | formatDate }}
          </template>
        </AppDataTable>
      </div>
      <!-- end table -->

      <!-- pagination -->
      <div class="py-4 flex items-center justify-start">
        <AppPagination
          :options="options"
          :startNumberItem="startNumberItem"
          :endNumberItem="endNumberItem"
          :totalItems="filterAnnouncements.total"
          :isPrevPage="isPrevPage"
          :isNextPage="isNextPage"
          @decreasePage="() => options.page--"
          @increasePage="() => options.page++"
          @itemsPerPageChange="() => (options.page = 1)"
        />
      </div>
      <!-- end pagination -->
    </div>

    <transition
      enter-active-class="transition ease-in-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in-out duration-300"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        @click="onCloseForm"
        v-if="
          (isOpen && formAction === 'add') ||
          (isOpenFormSendAnnouncement && formAction === 'edit')
        "
        class="fixed inset-0 bg-gray-900 bg-opacity-30"
      />
    </transition>

    <!-- form -->
    <AppSlideOverPanel :isOpen="isOpen">
      <FormAnnouncement
        :formAction="formAction"
        :announcementInit="announcementInit"
        :announcement="announcement"
        @onClose="onCloseForm"
        @onCancel="onCancelForm"
        @isDataChange="(value) => (isDataFormChange = value)"
        @onDelete="onDelete"
        @onSendAnnouncement="() => (isOpenFormSendAnnouncement = true)"
        @updateAnnouncement="handleUpdateAnnouncement"
      />
    </AppSlideOverPanel>
    <!-- end form -->

    <!-- form send announcement -->
    <AppSlideOverPanel :isOpen="isOpenFormSendAnnouncement">
      <FormSendAnnouncement
        :announcement="announcement"
        @onGoBack="onGoBackForm"
        @isSendAnnouncementDataChange="
          (value) => (isSendAnnouncementDataFormChange = value)
        "
        @onSendAnnouncementSuccess="onSendAnnouncementSuccess"
      />
    </AppSlideOverPanel>
    <!-- end form send announcement -->

    <!-- confirm delete -->
    <AppConfirmDeleteModal
      :show="isDelete"
      :loading="deleteLoading"
      :items="deleteItems"
      :errors="deleteErrors"
      @clear="deleteErrors = []"
      @cancel="onCancelConfirmDelete"
      @submit="onSubmitConfirmDelete"
    >
      <template v-slot:info>คุณต้องลบข้อมูลส่งประกาศ?</template>
      <template v-slot="{ items }">
        <ul>
          <li
            v-for="item in items"
            :key="item.system_announcement_uuid"
            class="text-base text-red-500 list-disc list-inside"
          >
            {{ item.title }}
          </li>
        </ul>
      </template>
    </AppConfirmDeleteModal>
    <!-- end confirm delete -->

    <!-- confirm leave page -->
    <AppConfirmLeavePageModal
      :show="isConfirmLeavePageShow"
      :type="isConfirmLeavePageType"
      :next="isConfirmLeavePageNextFunction"
      @cancel="onCancelConfirmLeavePage"
      @submit="onSubmitConfirmLeavePage"
    >
      <template v-if="isConfirmLeavePageType === 'form'" v-slot:title
        >ต้องการปิดใช่ไหม</template
      >
      <template v-if="isConfirmLeavePageType === 'form'" v-slot:message
        >คุณยังไม่ได้บันทึกข้อมูลของคุณ
        คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล ?</template
      >
    </AppConfirmLeavePageModal>
    <!-- end confirm leave page -->
  </div>
</template>

<script>
import moment from 'moment'

import SearchWidgetResultsList from '@/components/SearchWidgetResultsList'
import AppDataTable from '@/components/AppDataTable'
import AppPagination from '@/components/AppPagination'
import AppSlideOverPanel from '@/components/AppSlideOverPanel'
import FormAnnouncement from '@/components/FormAnnouncement'
import FormSendAnnouncement from '@/components/FormSendAnnouncement'
import AppConfirmDeleteModal from '@/components/AppConfirmDeleteModal'
import AppConfirmLeavePageModal from '@/components/AppConfirmLeavePageModal'

export default {
  name: 'AnnouncementList',

  components: {
    SearchWidgetResultsList,
    AppDataTable,
    AppPagination,
    AppSlideOverPanel,
    FormAnnouncement,
    FormSendAnnouncement,
    AppConfirmDeleteModal,
    AppConfirmLeavePageModal,
  },

  data() {
    return {
      loading: false,
      search: '',
      options: {
        sortBy: 'title',
        sortDesc: false,
        itemsPerPage: 10,
        page: 1,
      },
      announcement: {},
      announcementInit: {},
      isOpen: false,
      isOpenFormSendAnnouncement: false,
      formAction: '',
      isDelete: false,
      deleteLoading: false,
      deleteItems: [],
      timeout: null,
      isDataFormChange: false,
      isSendAnnouncementDataFormChange: false,
      isConfirmLeavePageShow: false,
      isConfirmLeavePageType: '',
      isConfirmLeavePageNextFunction: null,
      deleteErrors: [],
    }
  },

  filters: {
    formatDate: function (value) {
      return value ? moment(String(value)).format('DD/MM/YYYY HH:mm') : '-'
    },
  },

  watch: {
    search() {
      this.options.page = 1
    },
  },

  computed: {
    announcements() {
      return this.$store.state.announcement.announcements
    },

    filterAnnouncements() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let items = this.announcements

      if (this.search) {
        items = items.filter((item) => {
          return Object.values({
            title: item.title,
            created_at: item.created_at
              ? moment(item.created_at).format('DD/MM/YYYY')
              : '',
            sent_datetime: item.sent_datetime
              ? moment(item.sent_datetime).format('DD/MM/YYYY')
              : '',
            expired_datetime: item.expired_datetime
              ? moment(item.expired_datetime).format('DD/MM/YYYY')
              : '',
          }).some((s) =>
            s.toString().toLowerCase().includes(this.search.toLowerCase())
          )
        })
      }

      items = items.sort((a, b) => {
        let sortA = ''
        let sortB = ''
        if (sortBy === 'title') {
          sortA = a.title ? (a.title ? a.title : '') : ''
          sortB = b.title ? (b.title ? b.title : '') : ''
        }
        if (sortBy === 'created_at') {
          sortA = a.created_at ? (a.created_at ? a.created_at : '') : ''
          sortB = b.created_at ? (b.created_at ? b.created_at : '') : ''
        }
        if (sortBy === 'sent_datetime') {
          sortA = a.sent_datetime
            ? a.sent_datetime
              ? a.sent_datetime
              : ''
            : ''
          sortB = b.sent_datetime
            ? b.sent_datetime
              ? b.sent_datetime
              : ''
            : ''
        }
        if (sortBy === 'stat.send') {
          sortA = a.stat ? (a.stat.send ? a.stat.send : '') : ''
          sortB = b.stat ? (b.stat.send ? b.stat.send : '') : ''
        }
        if (sortBy === 'expired_datetime') {
          sortA = a.expired_datetime
            ? a.expired_datetime
              ? a.expired_datetime
              : ''
            : ''
          sortB = b.expired_datetime
            ? b.expired_datetime
              ? b.expired_datetime
              : ''
            : ''
        }

        if (sortDesc) {
          if (sortA < sortB) return 1
          if (sortA > sortB) return -1
          return 0
        } else {
          if (sortA < sortB) return -1
          if (sortA > sortB) return 1
          return 0
        }
      })

      const total = items.length

      if (itemsPerPage > 0) {
        items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
      }

      return { items, total }
    },

    startNumberItem() {
      if (this.filterAnnouncements.total === 0) return 0

      return (this.options.page - 1) * this.options.itemsPerPage + 1
    },

    endNumberItem() {
      const sum = this.options.page * this.options.itemsPerPage
      if (sum < this.filterAnnouncements.total) return sum

      return this.filterAnnouncements.total
    },

    isPrevPage() {
      if (this.options.page === 1) return true

      return false
    },

    isNextPage() {
      if (this.filterAnnouncements.items.length === 0) return true
      if (this.filterAnnouncements.length === 0) return true

      return (
        this.options.page ===
        Math.ceil(this.filterAnnouncements.total / this.options.itemsPerPage)
      )
    },
  },

  created() {
    this.$store.commit('setMenusCustomerActive', false)
    this.$store.commit('setBreadcrumbs', [
      { text: 'ส่งประกาศ', routeName: 'AnnouncementList' },
    ])

    this.fetchDataFromApi()
  },

  methods: {
    handleUpdateAnnouncement(announcement) {
      this.announcement = { ...announcement }
      this.announcementInit = { ...announcement }
    },

    onSendAnnouncementSuccess() {
      this.isOpenFormSendAnnouncement = false
      this.isOpen = false
      this.announcementInit = {}
      this.announcement = {}
      this.formAction = ''
    },

    onCancelConfirmLeavePage() {
      this.isConfirmLeavePageShow = false
    },

    onSubmitConfirmLeavePage(obj) {
      this.isDataFormChange = false
      this.isSendAnnouncementDataFormChange = false
      if (obj.type === 'form') {
        this.isConfirmLeavePageShow = false
        this.isOpen = false
        this.isOpenFormSendAnnouncement = false
        this.announcementInit = {}
        this.announcement = {}
        this.formAction = ''
        return
      }
      if (obj.type === 'page') {
        this.isConfirmLeavePageShow = false
        this.isOpen = false
        this.isOpenFormSendAnnouncement = false
        this.announcementInit = {}
        this.announcement = {}
        this.formAction = ''
        this.timeout = setTimeout(() => {
          obj.next()
        }, 500)
        return
      }
    },

    onCancelForm() {
      this.isDataFormChange = false
      this.isOpen = false
      this.announcement = {}
      this.announcementInit = {}
      this.formAction = ''
    },

    onCloseForm() {
      if (this.isDataFormChange || this.isSendAnnouncementDataFormChange) {
        this.isConfirmLeavePageShow = true
        this.isConfirmLeavePageType = 'form'
        return
      }
      if (this.formAction === 'edit' && this.isOpenFormSendAnnouncement) {
        this.isOpenFormSendAnnouncement = false
      } else {
        this.isOpen = false
        this.announcementInit = {}
        this.announcement = {}
        this.formAction = ''
      }
    },

    onGoBackForm() {
      this.isOpenFormSendAnnouncement = false
    },

    rowClassFunction(item) {
      if (
        this.announcement.system_announcement_uuid ===
        item.system_announcement_uuid
      ) {
        return 'cursor-pointer bg-gray-200'
      }
      return 'cursor-pointer hover:bg-gray-100'
    },

    onRowClick(item) {
      if (
        this.announcement.system_announcement_uuid ===
        item.system_announcement_uuid
      ) {
        this.onCloseForm()
      } else {
        this.isOpen = true
        this.formAction = 'edit'
        this.announcementInit = {
          ...item,
          created_at: item.created_at
            ? moment(item.created_at).format('DD/MM/YYYY HH:mm')
            : '',
          sent_datetime: item.sent_datetime
            ? moment(item.sent_datetime).format('DD/MM/YYYY HH:mm')
            : '',
          expired_datetime: item.expired_datetime
            ? moment(item.expired_datetime).format('DD/MM/YYYY HH:mm')
            : '',
        }
        this.announcement = {
          ...item,
          created_at: item.created_at
            ? moment(item.created_at).format('DD/MM/YYYY HH:mm')
            : '',
          sent_datetime: item.sent_datetime
            ? moment(item.sent_datetime).format('DD/MM/YYYY HH:mm')
            : '',
          expired_datetime: item.expired_datetime
            ? moment(item.expired_datetime).format('DD/MM/YYYY HH:mm')
            : '',
        }
      }
    },

    async fetchDataFromApi() {
      try {
        this.loading = true

        await this.$store.dispatch('announcement/fetchAnnouncements')
      } catch (error) {
        console.log(error.response)
      } finally {
        this.loading = false
      }
    },

    sort(value) {
      if (this.options.sortBy === value) {
        this.options.sortDesc = !this.options.sortDesc
        this.options.page = 1
      } else {
        this.options.sortBy = value
        this.options.sortDesc = false
        this.options.page = 1
      }
    },

    addAnnouncement() {
      this.isOpen = true
      this.formAction = 'add'
      this.announcementInit = {
        created_at: '',
        sent_datetime: '',
        expired_datetime: '',
      }
      this.announcement = {
        created_at: '',
        sent_datetime: '',
        expired_datetime: '',
      }
    },

    onDelete(item) {
      this.isDelete = true
      this.deleteItems = [{ ...item }]

      this.isOpen = false
    },

    onCancelConfirmDelete() {
      this.isDelete = false

      if (this.formAction === 'edit') {
        this.isOpen = true
      }

      this.deleteErrors = []
    },

    async onSubmitConfirmDelete(items) {
      this.deleteLoading = true

      for (const item of items) {
        try {
          await this.$store.dispatch(
            'announcement/deleteAnnouncement',
            item.system_announcement_uuid
          )
        } catch (error) {
          if (error.response && error.response.data) {
            this.deleteErrors.push(
              error.response.data.message || 'Something went wrong.'
            )
            this.deleteLoading = false
            return
          }

          console.log(error.response)
        }
      }

      this.deleteLoading = false
      this.isDelete = false
      this.deleteErrors = []

      const notification = {
        type: 'success',
        message: 'Your announcement has been deleted!',
      }
      this.$store.dispatch('notification/add', notification)

      this.formAction = ''
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDataFormChange || this.isSendAnnouncementDataFormChange) {
      this.isConfirmLeavePageShow = true
      this.isConfirmLeavePageType = 'page'
      this.isConfirmLeavePageNextFunction = next
      return
    }
    if (this.isOpen || this.isOpenFormSendAnnouncement) {
      this.isOpen = false
      this.isOpenFormSendAnnouncement = false
      this.timeout = setTimeout(() => {
        next()
      }, 500)
      return
    }

    next()
  },
}
</script>
